import {
	bulkUpdateMemberPoints200Schema,
	bulkUpdateMemberPointsMutationRequestSchema,
	getDailyPointSummary200Schema,
	getDailyPointSummaryPathParamsSchema,
	getDailyPointSummaryQueryParamsSchema,
	getMemberPointHistory200Schema,
	getMemberPointHistoryPathParamsSchema,
	getMemberPointHistoryQueryParamsSchema,
	updateMemberPoints200Schema,
	updateMemberPointsMutationRequestSchema,
	updateMemberPointsPathParamsSchema,
} from "../schemas/memberPointApi.schemas";
import type {
	BulkUpdateMemberPoints200Response,
	GetDailyPointSummary200Response,
	GetMemberPointHistory200Response,
	UpdateMemberPoints200Response,
} from "../types/memberPointApi.types";

/**
 * Shared endpoint contract configuration for member points
 * This ensures both client and server use the same endpoint definitions
 */
export const memberPointEndpointContract = {
	updateMemberPoints: {
		path: "/member/:memberId/points",
		method: "POST" as const,
		paramsSchema: updateMemberPointsPathParamsSchema,
		bodySchema: updateMemberPointsMutationRequestSchema,
		responseSchema: updateMemberPoints200Schema,
		responseType: {} as UpdateMemberPoints200Response,
	},
	getMemberPointHistory: {
		path: "/member/:memberId/points",
		method: "GET" as const,
		paramsSchema: getMemberPointHistoryPathParamsSchema,
		querySchema: getMemberPointHistoryQueryParamsSchema,
		responseSchema: getMemberPointHistory200Schema,
		responseType: {} as GetMemberPointHistory200Response,
	},
	getDailyPointSummary: {
		path: "/member/:memberId/point-summary",
		method: "GET" as const,
		paramsSchema: getDailyPointSummaryPathParamsSchema,
		querySchema: getDailyPointSummaryQueryParamsSchema,
		responseSchema: getDailyPointSummary200Schema,
		responseType: {} as GetDailyPointSummary200Response,
	},
	bulkUpdateMemberPoints: {
		path: "/member/points/bulk",
		method: "POST" as const,
		bodySchema: bulkUpdateMemberPointsMutationRequestSchema,
		responseSchema: bulkUpdateMemberPoints200Schema,
		responseType: {} as BulkUpdateMemberPoints200Response,
	},
} as const;
